import { Link } from "react-router-dom";

export const Logo = ({ className = "", size = "text-2xl" }) => (
  <Link to="/" data-testid="wordmark-gradetrack" className={`font-head font-bold tracking-tighter uppercase leading-none ${size} ${className}`}>
    <span className="text-gray-100">GRADE</span>
    <span className="text-yellow">TRACK</span>
  </Link>
);
